export const SET_UPDATED_PROFILE_LINK = (state, data) => {
    state.updatedProfileLink = data
}